import { useDraggable } from '@dnd-kit/core'

export const Draggable = ({
  element,
  id,
  data = {},
  classes,
  children,
  onClick = () => {},
  // prevent dragging of table elements
  disabled = false,
}) => {
  const Element = element || 'div'
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    data,
    disabled,
  })

  return (
    <Element
      id={id}
      className={classes}
      ref={setNodeRef}
      onClick={onClick}
      {...listeners}
      {...attributes}
    >
      {children}
    </Element>
  )
}
